function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useCallback } from 'react';
import { useColor } from './useColor';
export function useColorFields() {
  var manager = useColor();
  var rgba = manager.getColor().getRGBA();
  var hsl = manager.getColor().getHSL();
  var onHueChange = useCallback(function (value) {
    manager.emitColorChange(manager.getColor().setHue(value));
  }, []);
  var onSaturationChange = useCallback(function (value) {
    manager.emitColorChange(manager.getColor().setSaturation(value));
  }, []);
  var onLightChange = useCallback(function (value) {
    manager.emitColorChange(manager.getColor().setLight(value));
  }, []);
  var onRedChange = useCallback(function (value) {
    manager.emitColorChange(manager.getColor().setRed(value));
  }, []);
  var onGreenChange = useCallback(function (value) {
    manager.emitColorChange(manager.getColor().setGreen(value));
  }, []);
  var onBlueChange = useCallback(function (value) {
    manager.emitColorChange(manager.getColor().setBlue(value));
  }, []);
  var onAlphaChange = useCallback(function (value) {
    manager.emitColorChange(manager.getColor().setAlpha(value));
  }, []);
  return [_objectSpread(_objectSpread({}, rgba), hsl), {
    onHueChange: onHueChange,
    onSaturationChange: onSaturationChange,
    onLightChange: onLightChange,
    onRedChange: onRedChange,
    onGreenChange: onGreenChange,
    onBlueChange: onBlueChange,
    onAlphaChange: onAlphaChange
  }];
}